import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMfaIssueDetails } from 'src/apps/mfa/services/MfaSingleSessionService';
import { MFA_ISSUE_DETAILS } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { MobileIssueDetails } from 'src/common/types/MobileSingleSessionTypes';

export const useMfaIssueDetailsQuery = (
	issueId: string,
	runId: string,
	onError?: (error: unknown) => void
): UseQueryResult<MobileIssueDetails> => {
	return useQuery([MFA_ISSUE_DETAILS, issueId, runId], () => getMfaIssueDetails(issueId, runId), {
		onError
	});
};
